import { ComponentType, lazy } from 'react';

const PREFIJO = 'chunk-recargado:';

/**
 * Carga un chunk; si falla (típico tras un despliegue: el hash del archivo cambió), recarga la página una sola vez.
 * La marca vive en sessionStorage (con try/catch: puede no existir); si la recarga ya se intentó, relanza el error.
 */
export async function importConRecarga<T>(
  factory: () => Promise<T>,
  clave: string,
  recargar: () => void = () => window.location.reload(),
): Promise<T> {
  const marca = PREFIJO + clave;
  try {
    const modulo = await factory();
    try {
      sessionStorage.removeItem(marca);
    } catch {
      /* sin sessionStorage: nada que limpiar */
    }
    return modulo;
  } catch (err) {
    let yaIntentado = true;
    try {
      yaIntentado = sessionStorage.getItem(marca) === '1';
      if (!yaIntentado) sessionStorage.setItem(marca, '1');
    } catch {
      yaIntentado = true; // sin sessionStorage no se puede evitar el bucle: no se recarga
    }
    if (yaIntentado) throw err;
    recargar();
    return new Promise<T>(() => {}); // la página se está recargando: no resuelve
  }
}

export function lazyConRecarga<C extends ComponentType<any>>(factory: () => Promise<{ default: C }>, clave: string) {
  return lazy(() => importConRecarga(factory, clave));
}
